module.exports = __webpack_public_path__ + "logo_equals_quadrado.svg?b176262c1ad86ac6fea2c75fefc2e8cd";


//////////////////
// WEBPACK FOOTER
// ./client/assets/logos_equals/logo_equals_quadrado.svg
// module id = 1140
// module chunks = 0